export default "/images/vendor/flag-icon-css/flags/4x3/vg.svg?621c3ad6350a59e282ba1b49c6d2a3c5";